import { SyntheticEvent, ChangeEvent } from 'react';
import {
	FIELD_BB_TYPE,
	FIELD_DATA_ATTR,
	FIELD_EDIT_MODE,
} from 'client/components/common/BuildingBlocks/Fields/constants';

export type TFieldState = {
	editMode: (typeof FIELD_EDIT_MODE)[keyof typeof FIELD_EDIT_MODE];
	value: string;
	readOnly: boolean;
	pending: boolean;
};

export type TFieldProps = {
	className: string;
	type: (typeof FIELD_BB_TYPE)[keyof typeof FIELD_BB_TYPE];
	name: string;
	placeholder?: string;
	autoComplete?: 'off';
	[FIELD_DATA_ATTR]: string;
	value?: TFieldState['value'];
	readOnly?: TFieldState['readOnly'];
	onDoubleClick?: (e: SyntheticEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
	onChange?: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
	onBlur?: (e: SyntheticEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
	onFocus?: (e: SyntheticEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
	onClick?: (e: SyntheticEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
};

export enum DateFormat {
	DDMMYYYY = 'DDMMYYYY',
	MMDDYYYY = 'MMDDYYYY',
	YYYYMMDD = 'YYYYMMDD',
}

export enum DateDelimiter {
	'.' = '.',
	'/' = '/',
	'-' = '-',
}
